import { render, staticRenderFns } from "./ParcelamentoRead.vue?vue&type=template&id=0a9bbeb9&"
import script from "./ParcelamentoRead.vue?vue&type=script&lang=js&"
export * from "./ParcelamentoRead.vue?vue&type=script&lang=js&"
import style0 from "./ParcelamentoRead.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports